// react
import React, { useEffect, useContext, useRef } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import logoCSJ from 'assets/img/logo-csj-sistemas.png';
import logoItau from 'assets/img/logo-itau.png';

// material-ui components
import { TextField, Checkbox, FormHelperText, CircularProgress } from '@material-ui/core';
import { Dialog, DialogContent, DialogTitle, Slide } from '@material-ui/core';
import Alert from '@mui/material/Alert';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";

// services
import { MaskMoney, transformValueFormatedtoFloat, formateDate, MaskCel, transformValueFloattoFormated } from "beaktShared/helpers/masks";
import { SessionContext, getLanguageSelected } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/pagamentoDinheiro.js";

const useStyles = makeStyles({
    styles,
    customTextField: {
        '& .MuiOutlinedInput-root': {
          color: '#00305c', // Cor do texto inserido no campo
          borderRadius: '0',
          border: '1px solid #60bf18 !important',
          '&.Mui-focused': {
            border: '1px solid #4c9813 !important',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#60bf18',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#4c9813',
          },
          '& .MuiOutlinedInput-input': {
            padding: '10px !important',
          },
        },
        '& .MuiInputBase-input': {
          color: '#00305c',
        },
        '& .MuiInputLabel-root': {
          color: '#00305c',
        },
        '& .MuiInputLabel-shrink': {
          color: '#00305c',
        },
        '& .MuiInputBase-input::placeholder': {
          color: '#00305c',
          opacity: 1, 
        },
    },
    gridClass: {
        padding: '0 5px !important', 
    },
    custonButton: {
        backgroundColor: '#60bf18',
        '&:hover': {
        backgroundColor: '#4c9813',
        },
        '&:focus': {
        backgroundColor: '#60bf18',
        },
        '&:active': {
        backgroundColor: '#60bf18',
        },
    },
    customCheckbox: {
        color: '#60bf18',
    
        '&:hover': {
          backgroundColor: 'rgba(76, 152, 19, 0.1)', // Fundo com leve transparência
          color: '#4c9813',
        },
    
        '&.Mui-checked': {
          color: '#60bf18', // Cor quando o checkbox está marcado
    
          '&:hover': {
            color: '#4c9813', // Cor ao passar o mouse sobre um checkbox marcado
          },
        },
    },
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function PagamentoPix({ pgto, CallloadTotalizadorPgtos, clienteId }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const session = useContext(SessionContext);
    const {register, errors, handleSubmit, setValue} = useForm({mode: "onBlur"});

    const endPoint = "estabelecimentoSolicitacao/";
    const endPointPix = "beaktPaymentPixIntegrado/";

    const tempoLimiteConsulta = 120000; // padrão para 120000 (2 minutos)
    const tempoDeCadaConsulta = 5000; // padrão para 5000 (5 segundos)

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification({ show: false });
        }, 5000);
    };
    
    const [LoadingForm, setLoadingForm]= React.useState(false);
    const [pixLiberado, setPixLiberado] = React.useState(false);
    const [solicitacaoPendente, setSolicitacaoPendente] = React.useState(false);
    const [solicitacaoRecusada, setSolicitacaoRecusada] = React.useState(false);
    const [showModalRequisicao, setShowModalRequisicao] = React.useState(false);
    const [perfilLiberado, setPerfilLiberado] = React.useState(false);
    
    const [isChecking, setIsChecking] = React.useState(false);
    const [timeElapsed, setTimeElapsed] = React.useState(120000);
    const intervalRef = React.useRef(null); 
    
    const startCountdown = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }

        intervalRef.current = setInterval(() => {
            setTimeElapsed(prevTime => {
            const newTime = prevTime + tempoDeCadaConsulta;

            if (newTime >= tempoLimiteConsulta) {
                clearInterval(intervalRef.current);
                setIsChecking(false);
            }
            else
            {
                handleGetStatusQRCode(false);
            }

            return newTime;
            });
        }, tempoDeCadaConsulta);
    };

    const handleRequisicao = (showModal) => {
        if(showModal)
            setShowModalRequisicao(true);
    };
    
    const [dataRecusa, setDataRecusa] = React.useState('');
    const [motivoRecusa, setMotivoRecusa] = React.useState('');

    const loadSolicitacao = () => {
        setTimeElapsed(0);
        setLoadingForm(true);
        UseGetApiSimple(endPoint + "byestabelecimento/" + session.estabelecimentoId).then(result=> {
            if(result.status !== 200)
            {
                if (result.message !== null && result.message !== undefined)
                {
                    showNotification('Solicitação | Erro: ' + result.message, 'error');
                }
                setLoadingForm(false);
                setPixLiberado(false);
                return false;
            }
            
            setPixLiberado(false);
            setSolicitacaoPendente(false);
            setSolicitacaoRecusada(false);

            if (result.data !== '')
            {
                if (result.data.status === 1)
                {
                    setPixLiberado(true);
                }
                else if (result.data.status === 2)
                {
                    setSolicitacaoPendente(true);
                }
                else if (result.data.status === 3)
                {
                    if (result.data.dataAnalise !== '')
                    {
                        setDataRecusa(formateDate(result.data.dataAnalise));
                    }
                    setMotivoRecusa(result.data.motivoRecusa);
                    setSolicitacaoRecusada(true);
                }
            }
            
            setLoadingForm(false);
        }); 
    };
    
    const [nome, setNome] = React.useState('');
    const [celular, setCelular] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [aceite, setAceite] = React.useState(false);
    
    const [dadosQRCode, setDadosQRCode] = React.useState(null);
    const [exibeQRCode, setExibeQRCode] = React.useState(false);

    const handleEnviaSolicitacao = () => {
        const newErrors = [];

        if (!nome.trim()) {
            newErrors.push('Nome é obrigatório');
        }
        if (!celular.trim()) {
            newErrors.push('Celular é obrigatório');
        }
        if (!email.trim()) {
            newErrors.push('E-mail é obrigatório');
        }
        if (!aceite) {
            newErrors.push('Você deve autorizar a coleta de dados');
        }

        if (newErrors.length > 0) {
            showNotification('Preencha todos os campos para enviar a solicitação.', 'warning');
            return false;
        }
        
        let dataSolicitacao = {
            EstabelecimentoId: session.estabelecimentoId,
            Tipo: 'PIX Integrado',
            Nome: nome,
            Celular: celular,
            Email: email,
            UsuarioId: session.id,
        }

        setLoadingForm(true);
        UsePostApi(endPoint, dataSolicitacao).then(result=> {
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');
                setLoadingForm(false);  
                return false; 
            }

            showNotification(result.message, 'success');

            setNome('');
            setCelular('');
            setEmail('');
            setAceite(false);
            
            setShowModalRequisicao(false);
            setLoadingForm(false);
            loadSolicitacao();
            return true;    
        });
    };
    
    const onSubmit = (data, e) => {
        e.preventDefault();
        setLoadingForm(true);
        let valor = transformValueFormatedtoFloat(data.valor);

        if(valor > pgto.totalizadorPagamentos.valorPendente.toFixed(2))
        {
            showNotification(t('error_message.the_amount_must_be_equal_or_less_than_the_balance_to_pay'), 'warning');
            setLoadingForm(false);  
            return false;
        }

        let sendGerateQRCode = {
            tipo: 'INSTANTANEO',
            descricao: 'PIX Integrado',
            externalReference: '',
            chavePix: '',
            valor: valor,
        }

        let gerateQRCode = {
            sendGerateQRCode: sendGerateQRCode,
            estabelecimentoId: session.estabelecimentoId,
            clienteId: clienteId,
        }
        
        UsePostApi(endPointPix + 'gerateQRCode', gerateQRCode).then(result => {
            if (result.status !== 200) {
                setDadosQRCode(null);
                setExibeQRCode(false);
                setLoadingForm(false);
                showNotification(result.message, 'error');
                return false;
            }
            else 
            {
                showNotification('QRCode gerado com sucesso.', 'success');
                setDadosQRCode(result.data);
                setTimeElapsed(0);
                setIsChecking(true);
                setExibeQRCode(true);
                setLoadingForm(false);
                return true;
            }
        });

        setLoadingForm(false);
        return true;
    };
    
    const handleGetStatusQRCode = (exibeMensagem) => {
        setLoadingForm(true);
        UseGetApiSimple(endPointPix + "getStatusQRCode/" + session.estabelecimentoId + "/" + dadosQRCode?.orderId).then(result => 
        {
            if (result.status !== 200) 
            {
                setLoadingForm(false);
                if (exibeMensagem)
                {
                    showNotification('Erro na consulta do status do pagamento PIX.', 'error');
                }
                return false;
            }
            else 
            {
                if (result.data !== '')
                {
                    if (result.data.status === 'PAGO')
                    {
                        let valor = result.data.amount;
                        
                        let pg = {
                            id: pgto.pagamentos.length+1,
                            tipo: 5, // 0- Dinheiro / 1-Cartão / 2-Boleto / 3-Cheque / 4-Outros / 5-PIX
                            descricaoFormaPgto: 'PIX Integrado',
                            valor: valor,
                            descTipo: 'PIX Integrado',
                            parcela: 1,
                            descPacela: t('label.at_sight'),
                            orderId: dadosQRCode?.orderId,
                        }
                
                        let updatepgto ={
                            ...pgto,        
                            pagamentos:[
                            ...pgto.pagamentos,
                            pg
                            ]
                        }
                        
                        setTimeElapsed(240000);
                        setIsChecking(false);
                        setDadosQRCode(null);
                        setExibeQRCode(false);
                        setValue("valor", "");
                        CallloadTotalizadorPgtos(updatepgto);
                        setLoadingForm(false);
                        showNotification('Pago com sucesso, prossiga com a finalização da venda.', 'success');
                        return true;
                    } 
                    else 
                    {
                        setLoadingForm(false);
                        if(exibeMensagem)
                        {
                            if(result.data.status === 'CANCELADO')
                            {
                                showNotification('QRCode do pagamento PIX esta cancelado, clique no botão CANCELAR QRCODE, para gerar um novo.', 'warning');
                            }
                            else
                            {
                                showNotification('Status do pagamento PIX: ' + result.data.status, 'warning');
                            }
                        }
                        return false;
                    }
                }
                else 
                {
                    setLoadingForm(false);
                    showNotification('Não foi possível determinar o status do PIX.', 'warning');
                    return false;
                }
            }
        });
    };

    const handleCancelQRCode = () => {
        setLoadingForm(true);
        let orderId = dadosQRCode?.orderId;
        let amount = dadosQRCode?.amount;

        let sendCancelQRCode = {
            order_id: orderId,
            valor: amount,
        }

        let requestCancelQRCode = {
            SendCancelQRCode: sendCancelQRCode,
            EstabelecimentoId: session.estabelecimentoId
        }

        UsePostApi(endPointPix + 'cancelQRCode', requestCancelQRCode).then(result => {
            if (result.status !== 200) 
            {
                showNotification('Erro ao cancelar QRCode do pagamento PIX.', 'error');
                setLoadingForm(false);
                return false;
            }
            else
            {
                showNotification('QRCode do pagamento PIX cancelado com sucesso.', 'success');
                setIsChecking(false);
                setDadosQRCode(null);
                setExibeQRCode(false);
                setLoadingForm(false);
            }
        });
    };

    const handleCopyQRCode = () => {
        navigator.clipboard.writeText(dadosQRCode?.qrCodeUrl)
        .then(() => {
            showNotification('Link copiado com sucesso.', 'success');
        })
        .catch(err => {
            showNotification('Erro ao copiar o conteúdo: '+  err, 'error');
        });
    };

    useEffect(() => {
        if (dadosQRCode !== null) 
        {
            startCountdown();
        }
        return () => 
        {
            if (intervalRef.current) 
            {
                clearInterval(intervalRef.current);
            }
        };
    }, [dadosQRCode]);

    useEffect(() => {
        loadSolicitacao();
        if (session.tipoPerfil === 1 || session.id === 1)
        {
            setPerfilLiberado(true);
        }
        else
        {
            setPerfilLiberado(false);
        }

        const reloadedPagamentoPix = sessionStorage.getItem('reloadedPagamentoPix');
        if (!reloadedPagamentoPix) {
        window.location.reload(true);
        sessionStorage.setItem('reloadedPagamentoPix', 'true');
        }
        return () => {
        sessionStorage.removeItem('reloadedPagamentoPix');
        };

    }, []);

    return (
        <div style={{ width: '95%' }}>
            {
                notification.show &&
                <Alert icon={false} severity={notification.color}>
                    {notification.message}
                </Alert>
            }
            { pixLiberado ? (
                exibeQRCode ? (
                    <>
                        <hr style={{ margin: '10px 0' }} />
                        <GridContainer className={classes.containerin} style={{ alignItems: 'center', textAlign: 'center' }}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h5 style={{ color: '#6c757d' }}>
                                    Utilize o QRCode abaixo para efetuar o pagamento do valor de 
                                    <span style={{ fontWeight: 'bold' }}> R$ {transformValueFloattoFormated(dadosQRCode?.amount)}</span>
                                </h5>
                            </GridItem>
                        </GridContainer>
                        <hr style={{ margin: '10px 0' }} />
                        <GridContainer className={classes.containerin} style={{ alignItems: 'center', textAlign: 'center' }}>
                            <GridItem xs={12} sm={12} md={12}>
                                <img 
                                    style={{ maxWidth: '350px' }}
                                    src={`${dadosQRCode?.qrCode}`} 
                                    alt="QR Code" />
                            </GridItem>
                        </GridContainer>
                        <hr style={{ margin: '10px 0' }} />
                        <GridContainer className={classes.containerin} style={{ alignItems: 'center', textAlign: 'center' }}>
                            <GridItem xs={12} sm={12} md={12}>
                                <Button
                                    onClick={handleCopyQRCode}>
                                    Clique aqui para copiar o QRCode
                                </Button>
                            </GridItem>
                        </GridContainer>
                        <hr style={{ margin: '10px 0' }} />
                        <GridContainer className={classes.containerin} style={{ alignItems: 'center', textAlign: 'center' }}>
                            {
                                isChecking ? (
                                    <>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <h5 style={{ fontWeight: 'bold', padding: '10px 0', color: '#6c757d' }}>
                                                AGUARDANDO PAGAMENTO ...
                                            </h5>
                                        </GridItem>
                                    </>
                                ) : (
                                    <>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <Button color="primary" onClick={() => handleGetStatusQRCode(true)} >
                                                Consulta status do pagamento
                                            </Button>
                                        </GridItem>
                                    </>
                                )
                            }
                        </GridContainer>
                        <hr style={{ margin: '10px 0' }} />
                        <GridContainer className={classes.containerin} style={{ alignItems: 'center', textAlign: 'center' }}>
                            <GridItem xs={12} sm={12} md={12}>
                                <Button color="warning" onClick={() => handleCancelQRCode()} >
                                    Cancelar QRCode
                                </Button>
                            </GridItem>
                        </GridContainer>
                        <hr style={{ margin: '10px 0' }} />
                    </>
                ) : (
                    <form onSubmit={handleSubmit(onSubmit)} style={{ padding: '15px 0 0' }}>
                        <GridContainer className={classes.containerin} style={{ alignItems: 'center', textAlign: 'center' }}>
                            <GridItem xs={12} sm={3} md={3}>
                                <div className={classes.labelIdent}>
                                    {t('label.value')} *
                                </div>
                            </GridItem>
                            <GridItem xs={12} sm={6} md={6}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{shrink: true}} 
                                    defaultValue=""  
                                    name="valor"               
                                    InputProps={{ inputComponent: MaskMoney}}    
                                    inputRef={register({required: true})}
                                    error={errors.valor?true:false} 
                                />
                                <FormHelperText>
                                    {errors.valor && <span className="obg">{t('label.required')}</span>}
                                </FormHelperText>   
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.containerin}>
                            <GridItem xs={12} sm={12} md={12}>
                                <center>
                                    <Button type="submit" color="primary" >
                                        {t('button.generate_qr_code')}                    
                                    </Button>
                                    { LoadingForm && <CircularProgress /> }
                                </center>
                            </GridItem>
                        </GridContainer>
                    </form>
                )
            ) : (
                <>
                    { solicitacaoPendente ? (
                        <>
                            <GridContainer className={classes.containerin} >
                                <GridItem xs={12} sm={12} md={12}>
                                    <h4 style={{ textAlign: 'center' }}>
                                        Sua solicitação foi enviada para o Comercial CSJ.
                                        <br /> 
                                        Aguarde o retorno, ou, se preferir, entrar 
                                        <br />
                                        contato no email: <strong style={{ fontWeight: 'bold', color: '#6c757d' }}>comercial@csjsistemas.com.br</strong>
                                    </h4>
                                </GridItem>
                            </GridContainer>
                        </>
                    ) : (
                        <>
                            <div style={{ textAlign: 'center' }}>
                                { solicitacaoRecusada && (
                                    <>
                                        <GridContainer className={classes.containerin}>
                                            <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'center' }}>
                                                <h5 style={{ textAlign: 'center' }}>
                                                Essa solicitação foi recusada pelo motivo 
                                                <strong style={{ fontWeight: 'bold', color: '#6c757d' }}> {motivoRecusa}</strong>, 
                                                no dia 
                                                <strong style={{ fontWeight: 'bold', color: '#6c757d' }}> {dataRecusa}</strong>, 
                                                caso deseje mais detalhes, por favor, 
                                                entre em contato através do e-mail 
                                                <strong style={{ fontWeight: 'bold', color: '#6c757d' }}> comercial@csjsistemas.com.br</strong>.
                                                </h5>
                                            </GridItem>
                                        </GridContainer>
                                    </>
                                )}
                                <GridContainer className={classes.containerin}>
                                    <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'center' }}>
                                        <h5>Para liberar essa forma de pagamento, clique no botão abaixo e preencha o formulário.</h5>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                    <Button color="primary" onClick={() => handleRequisicao(true)}>
                                        Fazer pedido
                                    </Button>
                                    </GridItem>
                                </GridContainer>
                            </div>
                            <Dialog
                                open={showModalRequisicao}
                                TransitionComponent={Transition}
                                fullWidth
                                maxWidth="md"
                                onClose={() => setShowModalRequisicao(false)}
                                aria-labelledby="classic-modal-slide-title"
                                aria-describedby="classic-modal-slide-description"
                            >
                                <DialogContent style={{ textAlign: "center", padding: '16px 0 !important' }}>
                                    <div style={{ paddingBottom: '16px' }}>
                                        <GridContainer style={{ paddingBottom: '8px' }}>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <h2 style={{ color: '#00305c', fontWeight: 'bold', fontSize: '1.8rem' }}>
                                                    CSJ PIX by Itaú: Inovação, Praticidade e Segurança
                                                </h2>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6} style={{ borderRight: '2px solid #60bf18' }}>
                                                <div style={{ textAlign: 'right', color: '#00305c', paddingRight: '16px' }}>
                                                    <div>
                                                        <img src={logoCSJ} style={{maxWidth:'120px'}}/>
                                                    </div>
                                                    <div style={{ paddingTop: '24px', paddingBottom: '12px', fontSize: '12px', maxWidth: '420px', float: 'right', fontWeight: '400' }}>
                                                        <p>
                                                            A <strong style={{ fontWeight: 'bold' }}>CSJ Sistemas</strong>, líder em soluções inteligentes de PDV, em parceria estratégica
                                                            com o <strong style={{ fontWeight: 'bold' }}>Itaú</strong>, apresenta o <strong style={{ fontWeight: 'bold' }}>CSJ PIX by Itaú</strong>. Esta solução integra as 
                                                            funcionalidades mais modernas do <strong style={{ fontWeight: 'bold' }}>PIX</strong> às plataformas de vendas da <strong style={{ fontWeight: 'bold' }}>CSJ Sistemas</strong>,
                                                            proporcionando aos lojistas uma gestão de pagamentos eletrônicos eficiente e
                                                            preparada para o futuro das moedas digitais como o <strong style={{ fontWeight: 'bold' }}>DREX</strong>.
                                                        </p>
                                                        <p>
                                                            Com o <strong style={{ fontWeight: 'bold' }}>CSJ PIX by Itaú</strong>, os varejistas oferecem aos seus clientes a conveniência
                                                            de <strong style={{ fontWeight: 'bold' }}>recebimentos via PIX</strong> pelo <strong style={{ fontWeight: 'bold' }}>QR Code</strong>, beneficiando-se também de recursos
                                                            exclusivos como a <strong style={{ fontWeight: 'bold' }}>conciliação automática de pagamentos e a geração de
                                                            relatórios detalhados</strong>. Esta integração simplifica a rotina financeira das lojas,
                                                            <strong style={{ fontWeight: 'bold' }}>reduzindo custos, otimizando processos e evitando fraudes</strong>.
                                                        </p>
                                                        <p>
                                                            Para mais informações e contato sobre o <strong style={{ fontWeight: 'bold' }}>CSJ PIX by Itaú</strong>, convidamos você a
                                                            preencher o formulário e nossa equipe entrará em contato para apresentar
                                                            todos os benefícios e detalhes dessa solução
                                                        </p>
                                                    </div>
                                                </div>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <div style={{ textAlign: 'left', color: '#00305c', paddingLeft: '16px' }}>
                                                    <img src={logoItau} style={{maxWidth:'50px'}}/>
                                                    <div style={{ paddingTop: '20px' }}>
                                                        <h5 style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                                            Solicite mais informações sobre o PIX integrado:
                                                        </h5>
                                                        <div style={{ textAlign: 'right', paddingTop: '24px' }}>
                                                            
                                                            <GridContainer>
                                                                <GridItem xs={12} sm={2} md={2} className={classes.gridClass}>
                                                                    <div style={{ marginTop: '10px', textAlign: 'right', fontWeight: 'bold' }}>
                                                                        Nome:
                                                                    </div>
                                                                </GridItem>
                                                                <GridItem xs={12} sm={8} md={8} style={{ paddingBottom: '4px' }}>
                                                                    <TextField
                                                                        className={classes.customTextField}
                                                                        fullWidth
                                                                        variant='outlined'
                                                                        InputLabelProps={{shrink: true}} 
                                                                        defaultValue=""
                                                                        value={nome} // Valor do estado
                                                                        onChange={(e) => setNome(e.target.value)}
                                                                        name="nome"
                                                                        inputRef={register({required: true})}
                                                                        error={errors.nome?true:false}
                                                                        inputProps={{ maxLength: 32 }}
                                                                    />
                                                                </GridItem>
                                                            </GridContainer>
                                                            <GridContainer>
                                                                <GridItem xs={12} sm={2} md={2} className={classes.gridClass}>
                                                                    <div style={{ marginTop: '10px', textAlign: 'right', fontWeight: 'bold' }}>
                                                                        Celular:
                                                                    </div>
                                                                </GridItem>
                                                                <GridItem xs={12} sm={8} md={8} style={{ paddingBottom: '4px' }}>
                                                                    <TextField
                                                                        className={classes.customTextField}
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        InputLabelProps={{shrink: true}} 
                                                                        defaultValue=""
                                                                        value={celular}
                                                                        onChange={(e) => setCelular(e.target.value)}
                                                                        name="celular"
                                                                        inputRef={register({required: true})}
                                                                        error={errors.nome?true:false} 
                                                                        InputProps={{
                                                                            inputComponent: MaskCel,
                                                                            required: true
                                                                        }}
                                                                    />
                                                                </GridItem>
                                                            </GridContainer>
                                                            <GridContainer>
                                                                <GridItem xs={12} sm={2} md={2} className={classes.gridClass}>
                                                                    <div style={{ marginTop: '10px', textAlign: 'right', fontWeight: 'bold' }}>
                                                                        E-mail:
                                                                    </div>
                                                                </GridItem>
                                                                <GridItem xs={12} sm={8} md={8}>
                                                                    <TextField
                                                                        className={classes.customTextField}
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        InputLabelProps={{shrink: true}} 
                                                                        defaultValue=""
                                                                        value={email} // Valor do estado
                                                                        onChange={(e) => setEmail(e.target.value)}
                                                                        name="email"
                                                                        inputRef={register({required: true})}
                                                                        error={errors.email?true:false}
                                                                        inputProps={{ maxLength: 64 }}
                                                                    />
                                                                </GridItem>
                                                            </GridContainer>
                                                            <GridContainer style={{ paddingTop: '24px' }}>
                                                                <GridItem xs={12} sm={10} md={10}>
                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        className={classes.customCheckbox}
                                                                        checked={aceite}
                                                                        onChange={(e) => setAceite(e.target.checked)}
                                                                        inputRef={register({required: true})}
                                                                        name="aceite"
                                                                    />
                                                                    <span style={{ fontSize: '12px', marginLeft: '4px' }}>
                                                                        Autorizo a coleta dos meus dados pessoais com a
                                                                        <br />
                                                                        única finalidade de receber um contato comercial.
                                                                    </span>
                                                                </div>
                                                                </GridItem>
                                                            </GridContainer>
                                                            <GridContainer style={{ paddingTop: '24px', paddingBottom: '16px' }}>
                                                                { perfilLiberado ? (
                                                                    <GridItem xs={12} sm={10} md={10}>
                                                                        <Button 
                                                                            className={classes.custonButton} 
                                                                            onClick={() => handleEnviaSolicitacao()}>
                                                                            Enviar
                                                                        </Button>
                                                                    </GridItem>
                                                                ) : (
                                                                    <GridItem xs={12} sm={10} md={10}>
                                                                        <h4>
                                                                            Seu usuário não tem permissão para envio destes dados. Por favor, 
                                                                            verifique com o seu responsável.
                                                                        </h4>
                                                                    </GridItem>
                                                                )}
                                                            </GridContainer>
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    notification.show &&
                                                    <Alert icon={false} severity={notification.color}>
                                                        {notification.message}
                                                    </Alert>
                                                }
                                            </GridItem>
                                        </GridContainer>
                                    </div>
                                </DialogContent>
                            </Dialog>
                        </>
                    )}
                </>
            )}
        </div>
    );
}